<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-update-data="methods.updateData"
        :method-update-scheme="methods.updateScheme"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Form from "@/components/Form";

import { removeUserToRegions as updateData, getUserRegions } from "@/api/users";
import defaultScheme from "@/api/schemes/usersRegions";
import addCollectionsToScheme from "@/utils/addCollectionsToScheme";

const updateScheme = async (scheme, id) => {
  try {
    const { regions } = scheme.properties;

    const response = await getUserRegions(id);
    Object.assign(regions, {
      items: response.regions,
      params: { key: "id", label: "name", multiple: true },
    });
    scheme = await addCollectionsToScheme(scheme);
  } catch (err) {
    console.log(err);
  }
  return scheme;
};

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      scheme: defaultScheme,
      methods: {
        updateData,
        updateScheme: (scheme) => updateScheme(scheme, this.$route.params.id),
      },
    };
  },
};
</script>
